import { render, staticRenderFns } from "./ChangeNumber.vue?vue&type=template&id=5bc6671d&scoped=true&"
import script from "./ChangeNumber.vue?vue&type=script&lang=js&"
export * from "./ChangeNumber.vue?vue&type=script&lang=js&"
import style0 from "./ChangeNumber.vue?vue&type=style&index=0&id=5bc6671d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc6671d",
  null
  
)

export default component.exports